import { useEffect } from "react";

function useCookieDeclaration({ slotId, culture }) {
  useEffect(() => {
    const mountNode = document.getElementById(slotId);
    if (!mountNode) return;

    mountNode.innerHTML = "";

    const script = document.createElement("script");
    script.setAttribute("data-culture", culture);
    script.src =
      "https://consent.cookiebot.com/0895a818-c55d-422d-80a1-e7fd80c16a9b/cd.js";
    script.type = "text/javascript";
    script.async = true;

    mountNode.appendChild(script);

    return () => {
      mountNode.innerHTML = "";
    };
  }, [slotId, culture]);
}

export default useCookieDeclaration;
